import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import {OHeader} from '../../OHeader'
import OrganisationDashboard from '../../organisation/OrganisationDashboard';
import Organisationmenu from '../../organisation/organisationmenu/OrganisationMenu';
import OrganizationNeeds from '../../organisation/OrganizationNeeds';
import OrganizationDonations from '../../organisation/OrganizationDonations';
import OrganizationDocuments from '../../organisation/OrganizationDocuments';
import OrganizationFeedbacks from '../../organisation/OrganizationFeedbacks';
import OrganizationApplications from '../../organisation/OrganizationApplications';
import OrganizationDonorReports from '../../organisation/OrganizationDonorReports';
import OrganizationFundmanagerReports from '../../organisation/OrganizationFundmanagerReports';
import OrgAddFeedbacks from '../../organisation/OrgAddFeedbacks';
import { OrgSearchFundmanager } from '../../organisation/OrgSearchFundmanager';
import {OrgApplyApplication } from '../../organisation/OrgApplyApplication';
import OrgAddNeeds from '../../organisation/OrgAddNeeds';
import OrgEditNeeds from '../../organisation/OrgEditNeeds';
import OrgNeedsView from '../../organisation/OrgNeedsView';
import OrgViewApplication from '../../organisation/OrgViewApplication';
import OrgDonarChat from '../../organisation/OrgDonorChat';
import OrgFundReportGenerate from '../../organisation/OrgFundReportGenerate';
import OrgDonorReportGenerate from '../../organisation/OrgDonorReportGenerate';
import OrganizationProfile from '../../organisation/OrganizationProfile';
import {Footer} from '../../footer';
import { RestPass } from '../../resetpassword/ResetPassword';
import {MobileDonationlist} from '../../mobile/MobileDonationlist';
import MobileDashboard from '../../mobile/MobileOrgDashboard';
interface OrgLayoutProps {

  children?: ReactNode;
  // Define children as a ReactNode
}
const OrgLayout: React.FC<OrgLayoutProps> = ({ children }) => {

  return (
    <div className="admin-layout-container">
      <OHeader />
      <div className="row">
        <Organisationmenu />
        <div >
          <Routes>
            <Route path="/odashboard" element={<OrganisationDashboard />} />
            <Route path="/orgneeds" element={<OrganizationNeeds />} />
            <Route path="/receiveddonations" element={<OrganizationDonations />} />
            <Route path="/odocument" element={<OrganizationDocuments />} />
            <Route path="/ofeedback" element={<OrganizationFeedbacks />} />
            <Route path="/oorgapplications" element={<OrganizationApplications />} />
            <Route path="/donortranscript" element={<OrganizationDonorReports />} />
            <Route path="/fundmanagertranscript" element={<OrganizationFundmanagerReports />} />
            <Route path="/addfeedbacks" element={<OrgAddFeedbacks />} />
            <Route path="/searchfundmanager" element={<OrgSearchFundmanager />} />
            <Route path="/applyapplication/:fundman_id" element={<OrgApplyApplication />} />
            <Route path="/addneeds" element={<OrgAddNeeds />} />
            <Route path="/orgeditneeds/:Id" element={<OrgEditNeeds />} />
            <Route path="/latestneedsview/:Id" element={<OrgNeedsView />} />
            <Route path="/vieworgapp/:application_id" element={<OrgViewApplication />} />
            <Route path="/ochat/:donationID" element={<OrgDonarChat />} />
            <Route path="/oprinttranscript/:fundid/:rid" element={<OrgFundReportGenerate />} />
            <Route path="/odonorprinttranscript/:donorid/:rid" element={<OrgDonorReportGenerate />} />
            <Route path="/oprofile" element={<OrganizationProfile />} />
            <Route path="/oreset" element={<RestPass />} />
            <Route path="/mobdonationlist/:uid/:usertype" element={<MobileDonationlist/>} />
            <Route path="/mobdashboard/:uid/:usertype" element={<MobileDashboard/>} />
        
          </Routes>
        </div>
      </div>
      { children }
      <Footer />
    </div>
  );
};

export default OrgLayout;
